import { Freescout } from './Freescout';
export default Freescout